import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import Colapseimage from '../colapseimage/colapseimage.vue'
import FileEnterpriseRepository from '@/shared/http/repositories/realestate/fileenterprise'
import JSZip from 'jszip'
import { loading, toast } from '@/shared/utils/UIHelper'
import { saveAs } from 'file-saver'
export default {
  name: 'Boardmediaenterprise',
  components: {HeadDetailsGama, Colapseimage},
  props: ['data'],
  data () {
    return {
      changeAngel: false,
      posicaoEnumExclusao: null,
      dataFiles: [],
      posicaoEnum: null,
      dataGruposMidias: [],
      dataGruposMidiasOutros: [],
      dataGruposMidiasIncorporacao: [],
      imgDetails: '',
      search: '',
      searching: false,
      midiasSearch: [],
      isPdf: false,
      fileArray: [],
      ArrayTeste: [{descricao: 'ZIncorporação', enum: 4}, {descricao: 'ZCorretor', enum: 0}],
      isDragging: false,
      isHover: false,
      listArquiveid: [],
      teste: null,
      posicaoEncontrado: null,
      imgseguinte: '',
      nomearquivo: '',
      grupoarquivo: ''
    }
  },
  watch: {
    search (newvalue, old) {
      if (newvalue.length > 0) {
        this.searching = true
      } else {
        this.searching = false
      }
    }
  },
  computed: {
    GetdataGruposMidias: function () {
      return this.dataGruposMidias
    },
    GetdataGruposMidiasZincorporacao: function () {
      return this.dataGruposMidiasIncorporacao
    },
    GetdataGruposMidiasOutros: function () {
      return this.dataGruposMidiasOutros
    }
  },
  mounted () {
    this.getFiles()
  },
  methods: {
    pesquisar () {
      this.midiasSearch = this.dataFiles.filter((Element) => {
        if (Element.arquivo.descricao === null || Element.arquivo.descricao === undefined) return false
        if (Element.arquivo.descricao.toUpperCase().indexOf(this.search.toUpperCase()) > -1) return true
      })
    },
    verificarEditar (e) {
      if (e === 0 || e === 1) {
        if (this.dataFiles.filter((Element) => Element.tipo === e).length >= 1) {
          return false
        } else {
          return true
        }
      }
      return true
    },
    verificarPdf (i) {
      if (i === 4 || i === 6 || i === 7 || i === 8 || (i > 9 && i < 17)) return true
      return false
    },
    getFiles () {
      FileEnterpriseRepository.GetAllByEnterprise(this.data.id)
        .then(Response => {
          this.dataFiles = Response.data.data
          this.listArquiveid = this.dataFiles.map(element => element.id)
          // for (let i = 0; i < Response.data.data.length; i++) {
          //   this.dataFiles.push(Response.data.data[i])
          // }
          this.getEnumTypes()
          this.getEnumTypesZincorporacao()
          this.getEnumTypesOutros()
        })
        .catch(Error => loading.pop())
    },
    imageDetails (obj, type = null) {
      this.nomearquivo = ''
      this.posicaoEncontrado = this.listArquiveid.findIndex((element) => element === obj)
      this.nomearquivo = this.dataFiles[this.posicaoEncontrado].descricaoConteudo
      this.grupoarquivo = this.dataFiles[this.posicaoEncontrado].tipoDescricao
      this.getFileBase64(obj)
      this.isPdf = type === 'pdf'
      this.$refs.modalDetails.show()
    },
    getEnumTypes () {
      loading.push()
      FileEnterpriseRepository.GetEnumZcorretor()
        .then(Response => {
          this.dataGruposMidias = Response.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    getEnumTypesZincorporacao () {
      loading.push()
      FileEnterpriseRepository.GetEnumZincorporacao()
        .then(Response => {
          this.dataGruposMidiasIncorporacao = Response.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    getEnumTypesOutros () {
      loading.push()
      FileEnterpriseRepository.GetEnumOutros()
        .then(Response => {
          this.dataGruposMidiasOutros = Response.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    getTypes (type) {
      return this.dataFiles.filter(Element => Element.tipo === parseInt(type))
    },
    dawnloadGrup () {
      let cheked = []
      for (let i = 0; i < this.dataGruposMidias.length; i++) {
        if (document.getElementById('check' + this.dataGruposMidias[i].enum).checked) {
          cheked.push(this.dataGruposMidias[i].enum)
        }
      }
      var data = new FormData()
      var zip = new JSZip()
      if (cheked.length > 0) {
        for (let b = 0; b < cheked.length; b++) {
          data.append('TipoArquivo', cheked[b])
          // let get = this.dataFiles.filter(Element => Element.tipo === cheked[b])
          // if (get.length > 0) {
          //   let title = this.dataGruposMidias.filter(Element => Element.enum === cheked[b])
          //   let img = zip.folder(title[0].descricao)
          //   for (let z = 0; z < get.length; z++) {
          //     if (this.verificarPdf(get[z].tipo)) {
          //       img.file(get[z].arquivo.descricao + z + '.pdf', get[z].arquivo.arquivo, {base64: true, createFolders: true})
          //     } else {
          //       img.file(get[z].arquivo.descricao + z + '.jpeg', get[z].arquivo.arquivo, {base64: true, createFolders: true})
          //     }
          //   }
          // }
          loading.push()
          FileEnterpriseRepository.GetFileBase64ListByEnuns(this.data.id, data)
            .then((Response) => {
              for (let b = 0; b < cheked.length; b++) {
                let get = Response.data.filter(Element => Element.tipo === cheked[b])
                if (get.length > 0) {
                  let title = this.dataGruposMidias.filter(Element => Element.enum === cheked[b])
                  let img = zip.folder(title[0].descricao)
                  for (let z = 0; z < get.length; z++) {
                    img.file(get[z].arquivo.descricao, get[z].arquivo.arquivo, {base64: true, createFolders: true})
                  }
                }
              }
              loading.pop()
              zip.generateAsync({
                type: 'blob'
              }).then(function (content) {
                saveAs(content, 'midias.zip')
              })
            })
            .catch((Error) => {
              loading.pop()
            })
        }
      } else {
        toast.error('Selecione no mínimo um Grupo de Mídias')
      }
    },
    removeImg (e) {
      FileEnterpriseRepository.Delete(e.id)
        .then(Response => {
          this.posicaoEnumExclusao = e.tipo
          this.getFiles()
        })
        .catch(Error => loading.pop())
    },
    addImg (e) {
      document.getElementById('addinput-' + e.target.id).click()
    },
    getFileBase64 (id) {
      this.imgDetails = ''
      // loading.push()
      FileEnterpriseRepository.GetFileBase64(id)
        .then((Response) => {
          loading.pop()
          this.imgDetails = Response.data
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    onDragOver (e) {
      e.preventDefault()
      e.stopPropagation()
      e.dataTransfer.dropEffect = 'copy'
      e.dataTransfer.effectAllowed = 'copy'
      this.isHover = true
    },
    onDragEnter (e) {
      e.preventDefault()
      e.stopPropagation()
      e.dataTransfer.dropEffect = 'copy'
      e.dataTransfer.effectAllowed = 'copy'
      this.isHover = true
    },
    onDragLeave (e) {
      e.preventDefault()
      e.stopPropagation()
      this.isHover = false
    },
    SendImage (e) {
      loading.push()
      let fileArray = null
      if (e.target.files === undefined) {
        fileArray = e.dataTransfer.files
      } else {
        fileArray = e.target.files
      }
      for (var fileCounter = 0; fileCounter < (fileArray).length; fileCounter++) {
        let UrlConvert = URL.createObjectURL(fileArray[fileCounter])
        let obj = {
          data: fileArray[fileCounter],
          url: UrlConvert
        }
        let conf = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        let img = new FormData()
        img.append('img', obj.data)

        FileEnterpriseRepository.SendImgWithEmpreendimentoid(this.data.id, parseInt(e.target.id.replace('addinput-', '')), img, conf)
          .then(Response => {
            loading.pop()
            this.posicaoEnum = (parseInt(e.target.id.replace('addinput-', '')))
            this.dataFiles = []
            this.getFiles()
          })
          .catch((Error) => {
            toast.error(Error.response.data)
            loading.pop()
          })
      }
      loading.pop()
      this.isHover = false
    },
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = false
    },
    testeBack () {
      this.imgseguinte = ''
      this.posicaoEncontrado--
      this.imgseguinte = this.listArquiveid[this.posicaoEncontrado]
      this.nomearquivo = this.dataFiles[this.posicaoEncontrado].descricaoConteudo
      this.grupoarquivo = this.dataFiles[this.posicaoEncontrado].tipoDescricao
      this.getFileBase64(this.imgseguinte)
    },
    testeNext () {
      this.imgseguinte = ''
      this.posicaoEncontrado++
      this.imgseguinte = this.listArquiveid[this.posicaoEncontrado]
      this.nomearquivo = this.dataFiles[this.posicaoEncontrado].descricaoConteudo
      this.grupoarquivo = this.dataFiles[this.posicaoEncontrado].tipoDescricao
      this.getFileBase64(this.imgseguinte)
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/realestate/enterprise/components/boardmediaenterprise/boardmediaenterprise.js